module.exports = __webpack_public_path__ + "static/media/myflogo-big.cc3b4cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myflogo-big.png
// module id = 755
// module chunks = 0